import type { SiteThemeConfig } from '@/shared/providers/theme/types';
import { HITOWA_BRAND } from '../../../constants/brand';
import { hitowaConfig } from '../tenantConfig';

/**
 * Hitowa clinic-portal theme.
 *
 * This themes the classic RA2N console (login, and any screen not inside the
 * RAH shell). The RAH shell itself is themed by `styles/rah-shell.scss`.
 */
/** A2 (鍼灸): brand blue. */
const a2Colors = {
  primary: HITOWA_BRAND.brand,
  primaryHover: HITOWA_BRAND.brandHover,
  primaryActive: HITOWA_BRAND.brandDeep,
  primaryLight: HITOWA_BRAND.brandLight,
  primaryDark: HITOWA_BRAND.brandDeep,

  secondary: HITOWA_BRAND.accent,
  secondaryHover: HITOWA_BRAND.accentBright,
  secondaryActive: HITOWA_BRAND.accentDeep,

  text: HITOWA_BRAND.inkBody,
  textLight: HITOWA_BRAND.inkLabel,

  background: HITOWA_BRAND.canvas,
  surface: HITOWA_BRAND.surface,

  border: HITOWA_BRAND.border,

  // BC-60: the RAH sidebar is a light surface, not a dark rail.
  sidebarBg: HITOWA_BRAND.canvas,
  sidebarBgInactive: HITOWA_BRAND.brandPale,
  sidebarText: HITOWA_BRAND.inkBody,
  sidebarActive: HITOWA_BRAND.brand,

  menuOpen: 'rgba(0, 84, 172, 0.04)',
  menuHover: 'rgba(0, 84, 172, 0.08)',
  menuActive: 'rgba(0, 84, 172, 0.14)',

  headerBg: HITOWA_BRAND.surface,
  headerText: HITOWA_BRAND.inkBody,

  sectionHeader: HITOWA_BRAND.brand,
  sectionHeaderText: HITOWA_BRAND.surface,

  tableHeader: HITOWA_BRAND.brandPale,
  tableRowHover: HITOWA_BRAND.brandLight,
};

/** R2 (マッサージ): accent pink leads, brand stays the structural colour. */
const r2Colors = {
  ...a2Colors,
  primary: HITOWA_BRAND.accent,
  primaryHover: HITOWA_BRAND.accentBright,
  primaryActive: HITOWA_BRAND.accentDeep,
  primaryDark: HITOWA_BRAND.accentDeep,

  secondary: HITOWA_BRAND.brand,
  secondaryHover: HITOWA_BRAND.brandHover,
  secondaryActive: HITOWA_BRAND.brandDeep,

  sectionHeader: HITOWA_BRAND.accentDeep,
};

export const hitowaTheme: SiteThemeConfig = {
  siteType: 'hitowa',
  siteName: hitowaConfig.name,

  A2: {
    name: 'hitowa-a2',
    displayName: 'KEiLOG A2',
    logoPath: '/images/hitowa/keilog_text.png',
    colors: a2Colors,
    sidebarWidth: 'w-60',
  },

  R2: {
    name: 'hitowa-r2',
    displayName: 'KEiLOG R2',
    logoPath: '/images/hitowa/keilog_text.png',
    colors: r2Colors,
    sidebarWidth: 'w-60',
  },

  serviceSelector: {
    backgroundColor: HITOWA_BRAND.surface,
    buttonActiveOpacity: 'CC',
    buttonInactiveOpacity: '80',
  },
};
